module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Zollikon_COA-cd9c8b0404333c1e4a1fba2218a00e2e.svg";